import React, { useState, useEffect } from 'react';
import { Paperclip, Clock, Send, X } from 'lucide-react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';

const apiUrl = process.env.REACT_APP_API_URL;
console.log(apiUrl)
const SendBulkMail = () => {
  const BUId = sessionStorage.getItem("BUId");

  const [emailData, setEmailData] = useState({
    FromEmail: '',
    CampaignId: '', // Change to store the CampaignId
    TemplateId: '', // Change to store the TemplateId
    AttachmentPath: [],
    ScheduledDate: null,
    SendNow: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fromEmails, setFromEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState('');
  const [campaigns, setCampaigns] = useState([]); // State for campaigns
  const [templates, setTemplates] = useState([]); // State for templates

  // Fetch FromEmails, Campaigns, and Templates on mount
  useEffect(() => {
    const fetchFromEmails = async () => {
      try {
        const response = await fetch(`${apiUrl}/Mailer/GetFromMails?BUId=${BUId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch FromEmail options');
        }
        const data = await response.json();
        setFromEmails(data);
      } catch (error) {
        console.error('Error fetching FromEmail:', error);
      }
    };

    const fetchCampaigns = async () => {
      try {
        const response = await fetch(`${apiUrl}/Mailer/GetAssignedCampaignNames?BUId=${BUId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch Campaigns');
        }
        const data = await response.json();
        setCampaigns(data);
      } catch (error) {
        console.error('Error fetching campaigns:', error);
      }
    };

    fetchFromEmails();
    fetchCampaigns();

    return () => {
      window.tinymce?.remove();
    };
  }, [BUId]);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const maxSize = 10 * 1024 * 1024; // 10MB limit

    const oversizedFiles = files.filter(file => file.size > maxSize);
    if (oversizedFiles.length > 0) {
      alert('Some files exceed the size limit of 10MB');
      return;
    }

    setEmailData(prev => ({
      ...prev,
      AttachmentPath: files,
    }));
  };

  const removeFile = (indexToRemove) => {
    setEmailData(prev => ({
      ...prev,
      AttachmentPath: prev.AttachmentPath.filter((_, index) => index !== indexToRemove)
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate From email
    if (!emailData.FromEmail) {
      alert('Please select a From email address');
      return;
    }

    const scheduledDate = emailData.SendNow ? new Date() : emailData.ScheduledDate;

    // Validate required fields
    if (!emailData.CampaignId) {
      alert('Please fill in all required fields');
      return;
    }

    // Validate scheduled date
    // const minimumDate = new Date();
    // if (emailData.ScheduledDate <= minimumDate) {
    //   alert('Please select a future date and time');
    //   return;
    // }

    if (!scheduledDate || (scheduledDate <= new Date() && !emailData.SendNow)) {
      alert('Please select a valid future date and time');
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('BUId', BUId);
      formData.append('FromEmail', emailData.FromEmail);
      formData.append('CampaignId', emailData.CampaignId);  
      formData.append('ScheduledDate', scheduledDate.toISOString());
      formData.append('CreatedOn', format(new Date(), 'dd/MM/yyyy hh:mm a'));
      if (emailData.AttachmentPath.length > 0) {
        emailData.AttachmentPath.forEach(file => formData.append('AttachmentFile', file));
      }
// Log the FormData object entries
for (var pair of formData.entries()) {
  console.log(pair[0] + ": " + pair[1]);
}
console.log(apiUrl)

      const response = await fetch(`${apiUrl}/Mailer/ScheduleBulkEmail`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || 'Failed to schedule email');
      }

      alert('Email scheduled successfully!');

      // Reset form
      setEmailData({
        FromEmail: '',
        CampaignId: '', 
        // TemplateId: '', // Reset TemplateId
        AttachmentPath: [],
        ScheduledDate: null,
        SendNow: false,
      });

      setSelectedEmail('');

    } catch (error) {
      console.error('Scheduling error:', error);
      alert(`Failed to schedule email: ${error.message}`);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (event) => {
    const selected = event.target.value;
    setSelectedEmail(selected);
    setEmailData(prev => ({
      ...prev,
      FromEmail: selected
    }));
  };

  const handleSendNowChange = () => {
    setEmailData(prev => ({
      ...prev,
      SendNow: !prev.SendNow,
      ScheduledDate: null,
    }));
  };

  

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-gray-900">SCHEDULE EMAIL</h1>
      </div>

      <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-xl">
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* From Email Dropdown */}
          <div className="grid grid-cols-1 gap-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              From Email <span className="text-red-500">*</span>
            </label>
            <select
              id="fromEmail"
              value={selectedEmail}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select an Email</option>
              {fromEmails.map((emailObj, index) =>
                emailObj.fromEmails.map((email, emailIndex) => (
                  <option key={`${index}-${emailIndex}`} value={email}>
                    {email}
                  </option>
                ))
              )}
            </select>
          </div>

          {/* Campaign Dropdown */}
          <div className="grid grid-cols-1 gap-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Campaign Name <span className="text-red-500">*</span>
            </label>
            <select
              id="campaignName"
              value={emailData.CampaignId}  // Use CampaignId here
              onChange={(e) => setEmailData(prev => ({ ...prev, CampaignId: e.target.value }))}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a Campaign</option>
              {campaigns.map((campaign) => (
                <option key={campaign.campaignId} value={campaign.campaignId}>  {/* Use campaignId here */}
                  {campaign.campaignName}
                </option>
              ))}
            </select>
          </div>

          {/* Attachment File */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <Paperclip className="inline mr-2" size={16} />
              Attachments
            </label>
            <input
              type="file"
              multiple
              onChange={handleFileChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {emailData.AttachmentPath.length > 0 && (
              <div className="mt-2">
                <p className="text-sm font-medium mb-1">Selected Files:</p>
                {emailData.AttachmentPath.map((file, index) => (
                  <div key={index} className="flex items-center justify-between bg-gray-100 p-2 rounded mb-1">
                    <span className="text-sm">{file.name}</span>
                    <button
                      type="button"
                      onClick={() => removeFile(index)}
                      className="text-red-500"
                    >
                      <X size={16} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Scheduled Date */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              <Clock className="inline mr-2" size={16} />
              Schedule Date
              {/* Schedule Date<span className="text-red-500">*</span> */}
            </label>
            <DatePicker
              selected={emailData.ScheduledDate}
              onChange={(date) => setEmailData(prev => ({ ...prev, ScheduledDate: date }))}
              showTimeSelect
              dateFormat="Pp"
              placeholderText="Select date and time"
              className={`w-full px-3 py-2 border ${!emailData.ScheduledDate ? 'border-gray-500' : 'border-red-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500`}
              disabled={emailData.SendNow}  // Disable if SendNow is true
              required={!emailData.SendNow} // Make required only if SendNow is false
              minDate={new Date()}
              popperClassName="z-[9999]"
              calendarClassName="shadow-lg"
            />

            {/* Send Now Checkbox */}
            <input
              type="checkbox"
              name="Send Now"
              id="SendNow"
              checked={emailData.SendNow}
              onChange={handleSendNowChange}
              className="h-4 w-4 text-blue-500 border-gray-300 rounded ml-6"
            />
            <label htmlFor="SendNow" className="ml-2 text-sm font-medium text-gray-700">
              Send Now
            </label>

          </div>

          {/* Submit Button */}
          <div>
            <button
              type="submit"
              disabled={isSubmitting}
              className={`w-full flex items-center justify-center px-4 py-3 rounded-md text-white font-semibold ${isSubmitting ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'} focus:outline-none focus:ring-2 focus:ring-blue-500`}
            >
              {isSubmitting ? 'Scheduling...' : 'Schedule Email'}
              <Send className="ml-2" size={18} />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SendBulkMail;
